export default  class BeaconsService {

  constructor(Restangular) {
    'ngInject';
    this.Restangular = Restangular;
    this.SERVICE_NAME = 'beacons';
  }

  update(beaconKey, enabled, beaconType, beaconUrl) {
    let payload = {'enabled': enabled, 'beaconType': beaconType, 'url': beaconUrl};
    let promise = this.Restangular.oneUrl(this.SERVICE_NAME, `internal/v1/beacons/${beaconKey}`).customPUT(payload);
    return promise;
  }


}


